// extracted by mini-css-extract-plugin
export default {"footerWrap":"Footer_footerWrap__80Xv2","footerWrapper":"Footer_footerWrapper__+ihpa","links":"Footer_links__2VAlO","titleFooter":"Footer_titleFooter__M3XLP"};